import { FadeIn } from "react-slide-fade-in";

// eslint-disable-next-line import/no-anonymous-default-export,react/display-name
export default function ({
  className = "",
  children,
  ...props
}) {

  return (
    <FadeIn
      from="bottom"
      delayInMilliseconds={150}
      className={className}
      {...props}
    >
      {children}
    </FadeIn>
  );
}
